import o from "./cookieBannerStyles.mjs";
import e from "./fullPageCookieBannerStyles.mjs";
const t = {
  cookieBanner: o,
  fullPageCookieBanner: e
};
export {
  t as default
};
